import { useState } from "react";


export const usePostOcrAccountStates = () => {
  const [passbookName, setPassbookName] = useState("");

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    passbookName,
    setPassbookName,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
